import { getDetails, postDetails } from "../../services/http/http.service"
import { APIResponseCodes } from "../../utils/constants/keys.constants"
import store from "../store"
import { setMasterPageData, setPageData } from "./pageData.slice"

export const getPageData = (url: string) => {
    return async (dispatch: any) => {
        dispatch(setPageData([]))
        dispatch(setMasterPageData([]))
        const response = await getDetails(url, () => store.dispatch(getPageData(url)))
        if (response.statusCode === APIResponseCodes.SUCCESS) {
            dispatch(setPageData(response.data))
            dispatch(setMasterPageData(response.data))
        }
        return { statusCode: response.statusCode, data: response.data }
    }
}
export const postPageData = (url: string, payload: any) => {
    return async (dispatch: any) => {
        dispatch(setPageData([]))
        dispatch(setMasterPageData([]))
        const response = await postDetails(url, payload,() => store.dispatch(postPageData(url, payload)))
        if (response.statusCode === APIResponseCodes.SUCCESS) {
            dispatch(setPageData(response.data))
            dispatch(setMasterPageData(response.data))
        }
        return { statusCode: response.statusCode, data: response.data }
    }
}